import React from "react";
import { IColuna } from "../../../types/IColuna";

const _NOME_PARA_CABECALHO_MAP: Record<string, string> = {
    "DataProximoContato": "Próximo Contato",
}

const traduzirNomeColuna = (nomeColuna: string) =>
    nomeColuna in _NOME_PARA_CABECALHO_MAP ? _NOME_PARA_CABECALHO_MAP[nomeColuna] : nomeColuna

export type HeaderAtendimentoProps = {
  colunas: IColuna[];
};

export const HeaderAtendimento = (props: HeaderAtendimentoProps) => {
  return (
    <thead>
      <tr>
        {props.colunas.map(coluna =>
          coluna.Selecionada && (
            <th key={coluna.Nome} 
			  className={coluna.Classes}
              id={`HeaderAtendimento_Coluna_${coluna.Nome}_Th`}
            >
              {traduzirNomeColuna(coluna.Nome)}
            </th>
          )
        )}
      </tr>
    </thead>
  );
};
